let checkObjectExist = (
    vin,
    successAction = (response) => {
        if (response['data']['isExist']) {
            window.alert("Объект с данным номером кузова уже существует");
        }
    },
    failAction = (jqXHR) => {
        window.alert(
            "Ошибка при выполнении действия\n" +
            "Статус: " + jqXHR['statusText'] + "\n" +
            "Код статуса: " + jqXHR['status'] + "\n" +
            "Ответ сервера: " + jqXHR['responseText']
        );
    }
) => {
    $.get({cache: false, url: `/object/check-exist-by-vin?vin=${vin}`, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let addToReadyToSendList = (
    objectId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Execute action fail\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: "/object/add-object-to-ready-to-send-list", data: {objectId: objectId}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let removeFromReadyToSendList = (
    objectId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        window.alert(
            "Execute action fail\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({cache: false, url: "/object/remove-object-from-ready-to-send-list", data: {objectId: objectId}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let createIssueRequest = (
    objectId,
    plannedAt,
    comment,
    language = "english",
    successAction = (response) => {
        if (response['status'] === "success") {
            location.reload();
        } else {
            window.alert(response['msg']);
        }
    },
    failAction = (jqXHR) => {
        window.alert(
            "Execute action fail\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.post({
        cache: false,
        url: "/navis-sender/create-request-issue",
        data: {objectId: objectId, plannedAt: plannedAt, comment: comment, language: language}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let getNotRejectRecipient = (
    objectId,
    successAction = (response) => {
        if (response.data && response.data["notRejectRecipient"]) {
            location.reload();
        }
    },
    failAction = (jqXHR) => {
        window.alert(
            "Execute action fail\n" +
            "Status: " + jqXHR['statusText'] + "\n" +
            "Status code: " + jqXHR['status'] + "\n" +
            "Server response: " + jqXHR['responseText']
        );
    }
) => {
    $.get({cache: false, url: `/object/get-not-reject-recipient?id=${objectId}`, data: {}})
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

let setAdditionalType = (
    objectId,
    additionalTypeId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        // @ts-ignore
        defaultFailActionRu(jqXHR);
    }
) => {
    $.post({
        cache: false,
        url: "/object/set-additional-type?id=" + objectId,
        data: {additionalTypeId: additionalTypeId}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

const putUpForSale = (
    objectId,
    priceValue,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        // @ts-ignore
        defaultFailActionRu(jqXHR);
    }
) => {
    $.post({
        cache: false,
        url: "/object/put-up-for-sale?id=" + objectId,
        data: {priceValue: priceValue}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

const changePriceForSale = (
    objectId,
    priceValue,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        // @ts-ignore
        defaultFailActionRu(jqXHR);
    }
) => {
    $.post({
        cache: false,
        url: "/object/change-price-for-sale?id=" + objectId,
        data: {priceValue: priceValue}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

const withdrawFromSale = (
    objectId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        // @ts-ignore
        defaultFailActionRu(jqXHR);
    }
) => {
    $.post({
        cache: false,
        url: "/object/withdraw-from-sale?id=" + objectId,
        data: {}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

const toSell = (
    objectId,
    successAction = (response) => {
        location.reload();
    },
    failAction = (jqXHR) => {
        // @ts-ignore
        defaultFailActionRu(jqXHR);
    }
) => {
    $.post({
        cache: false,
        url: "/object/to-sell?id=" + objectId,
        data: {}
    })
        .done(function (response) {
            successAction(response);
        })
        .fail(function (jqXHR) {
            failAction(jqXHR);
        });
};

$(document).on('click', '#create-attachment', function (e) {
    e.preventDefault();
    const form = $('#create-attachment-form')[0];
    // @ts-ignore
    const formData = new FormData(form);

    $.ajax({
        url: `/object-attachment/create-attachment`,
        method: 'POST',
        data: formData,
        contentType: false,
        processData: false
    })
        .done(function (data) {
            alert(data.message)
            location.reload();
        })
        .fail(function (r) {
            alert(r.responseJSON.message);
            location.reload();
        });
});
